import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Admin } from '@mol-limo-reg/admin-api/model/models';
import { ProfileService } from '../../services/profile.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private accessTokenSubject = new BehaviorSubject<string | null>(localStorage.getItem('accessToken'));
  private profileSubject = new BehaviorSubject<Admin | null>(JSON.parse(localStorage.getItem('profile') ?? '{}'));
  public accessToken$: Observable<string | null>;
  public profile$: Observable<Admin | null>;
  public isLoggedIn$: Observable<boolean>;

  constructor(private authenticationService: AuthenticationService, private profileService: ProfileService, private router: Router) {
    this.accessToken$ = this.accessTokenSubject.asObservable();
    this.profile$ = this.profileSubject.asObservable();
    this.isLoggedIn$ = this.accessTokenSubject.asObservable().pipe(
      map((accessToken) => {
        return !!accessToken;
      })
    );
  }

  public accessToken() {
    return this.accessTokenSubject.value;
  }

  public profile() {
    return this.profileSubject.value;
  }

  public isLoggedIn() {
    return !!this.accessToken();
  }

  public logIn$(email: string, password: string) {
    return this.authenticationService.logIn$({ email, password }).pipe(
      map((response) => {
        this.setLogIn(response.accessToken);
        return response;
      })
    );
  }

  public logOut$() {
    return this.authenticationService.logOut$().pipe(
      map((response) => {
        this.setLogOut();
        return response;
      })
    );
  }

  private setLogIn(accessToken: string) {
    localStorage.setItem('accessToken', accessToken);
    this.accessTokenSubject.next(accessToken);
    this.router.navigate(['claim-management']);

    this.refreshProfile();
  }

  public setLogOut() {
    localStorage.removeItem('accessToken');
    this.accessTokenSubject.next(null);
    this.router.navigate(['login']);

    this.removeProfile();
  }

  public refreshProfile() {
    this.profileService.getProfile$().subscribe((profile) => {
      localStorage.setItem('profile', JSON.stringify(profile));
      this.profileSubject.next(profile);
    });
  }

  public removeProfile() {
    localStorage.removeItem('profile');
    this.profileSubject.next(null);
  }
}
